export const initialState = {
  // Last site the user picked, shared across every page that has a site
  // selector so the choice carries when they navigate. Persisted with the rest
  // of the store, so it also survives a reload.
  selectedSite: null,
  mySites: [],
  allSites: [],
  inventorySites: [],
  basketSitesIds: [],
  auctionSites: [],
  auctionSitesIds: [],
  dealDoneSites: [],
  wonSites: [],
  lostSites: [],
  editSites: undefined,
  sitesDetails: undefined,
  sitesDetailsId: '',
  customTime: undefined,
  timeStamp: undefined
};

export default function sitesReducer(state = initialState, action) {
  switch (action.type) {
    case 'SITES_SET_SELECTEDSITE': {
      return {
        ...state,
        selectedSite: action.data || null
      };
    }
    case 'SITES_FIND_ALLSITES': {
      if (action.data) {
        const allSites = action.data.allSites;

        return {
          ...state,
          allSites: allSites
        };
      }
      return initialState;
    }
    case 'SITES_FIND_ALLSITES_INVENTORY': {
      if (action.data) {
        const inventorySites = action.data.inventorySites;

        return {
          ...state,
          inventorySites: inventorySites
        };
      }
      return initialState;
    }
    case 'SITESS_SET_EDITSITES': {
      if (action.data) {
        const editSites = action.data;

        return {
          ...state,
          editSites: editSites
        };
      }
      return initialState;
    }
    case 'SITESS_SET_SITESDETAILSID': {
      if (action.data) {
        const id = action.data;
        return {
          ...state,
          sitesDetailsId: id
        };
      }
      return initialState;
    }
    default:
      return state;
  }
}
